import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getPerformance } from 'firebase/performance'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const isDevMode = () => import.meta.env.VITE_DEV_MODE === 'true'

// getAuth throws synchronously when apiKey is empty (e.g., CI E2E runs without secrets).
// In dev/E2E mode all auth calls are bypassed; a stub satisfies imports.
const hasFirebaseConfig = !!(import.meta.env.VITE_FIREBASE_API_KEY && import.meta.env.VITE_FIREBASE_APP_ID)

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
export const auth = hasFirebaseConfig ? getAuth(app) : ({} as ReturnType<typeof getAuth>)
// All data access goes through Cloud Functions — db and storage are not exported from frontend
export const functions = getFunctions(app, 'europe-west1')
export const perf = typeof window !== 'undefined' && hasFirebaseConfig ? getPerformance(app) : null
export const analytics = typeof window !== 'undefined' && hasFirebaseConfig ? getAnalytics(app) : null

// Connect to local emulators when VITE_USE_EMULATORS=true
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}
